import React from 'react';
import classnames from 'classnames';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { Field } from 'redux-form'

import './PercentageField.css';

const PercentageField = ({ name, compact = false, className, maxLength, ...rest }) => {
    return (
        <div className={classnames('PercentageField', compact && 'PercentageField--compact', className)}>
            <InputGroup>
                <Field
                    component="input"
                    type="text"
                    className="form-control"
                    name={name}
                    pattern="[0-9]+([\.][0-9]{1,2})?"
                    maxLength={maxLength ?? (compact ? 5 : undefined)}
                    {...rest}
                />
                <InputGroupAddon addonType="append">
                    <InputGroupText>%</InputGroupText>
                </InputGroupAddon>
            </InputGroup>
        </div>
    );
}

export default PercentageField;
